// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./_layout.tsx": { enumerable: true, get() { return require("C:\\Users\\Victor\\Documents\\Projects\\appCasal20\\src\\app\\_layout.tsx"); } },
  "./configuracoes.tsx": { enumerable: true, get() { return require("C:\\Users\\Victor\\Documents\\Projects\\appCasal20\\src\\app\\configuracoes.tsx"); } },
  "./despesas.tsx": { enumerable: true, get() { return require("C:\\Users\\Victor\\Documents\\Projects\\appCasal20\\src\\app\\despesas.tsx"); } },
  "./index.tsx": { enumerable: true, get() { return require("C:\\Users\\Victor\\Documents\\Projects\\appCasal20\\src\\app\\index.tsx"); } },
  "./login.tsx": { enumerable: true, get() { return require("C:\\Users\\Victor\\Documents\\Projects\\appCasal20\\src\\app\\login.tsx"); } },
  "./nova-venda.tsx": { enumerable: true, get() { return require("C:\\Users\\Victor\\Documents\\Projects\\appCasal20\\src\\app\\nova-venda.tsx"); } },
  "./produtos.tsx": { enumerable: true, get() { return require("C:\\Users\\Victor\\Documents\\Projects\\appCasal20\\src\\app\\produtos.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;